import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
class InvoicesAPI extends BaseHttp {
    constructor(config) {
        super();
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "getInvoicesForOdooProductSale", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (typeOfProduct, startDate, endDate) => {
                return this.privateRequest('get', `invoice/user?type=${typeOfProduct}&from_date=${startDate}&to_date=${endDate}&page=0`)
                    .then((response) => {
                    return response;
                });
            }
        });
        Object.defineProperty(this, "getPDF", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (url, date) => {
                const urlWithoutFirstSlash = url.substring(1);
                return this.privateRequest('get', urlWithoutFirstSlash)
                    .then((response) => {
                    const link = document.createElement('a');
                    link.href = `data:application/pdf;base64, ${escape(response)}`;
                    link.target = '_blank';
                    link.download = `Auto.de ${date} invoice.pdf`;
                    link.click();
                    link.remove();
                });
            }
        });
        this.setConfig(config);
    }
}
export default new InvoicesAPI({
    baseURL: config.invoicesAPI.url
});
